import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';

const NotActive = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-8 animate-in fade-in zoom-in duration-300">
        <div className="relative mx-auto w-24 h-24 bg-destructive/10 rounded-full flex items-center justify-center text-destructive">
          <Icon name="UserX" size={48} />
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-background rounded-full flex items-center justify-center">
            <Icon name="AlertCircle" size={18} className="text-destructive animate-pulse" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-black uppercase tracking-tight text-foreground">
            {t('not_active_page.title')}
          </h1>
          <p className="text-muted-foreground text-sm font-medium leading-relaxed">
            {t('not_active_page.message')}
          </p>
          <p className="text-[11px] text-muted-foreground/60 uppercase font-bold tracking-widest pt-4">
            {t('not_active_page.contact')}
          </p>
        </div>

        <div className="pt-6">
          <Button 
            variant="outline" 
            fullWidth 
            onClick={() => navigate('/landing-authentication')}
            className="border-border hover:bg-muted"
          >
            <Icon name="ArrowLeft" size={16} className="mr-2" />
            {t('not_active_page.back_home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotActive;